import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { error } from 'selenium-webdriver';
import { Gestor } from 'src/app/models/gestor.model';
import { GestorDTO } from 'src/app/models/gestorDTO.model';
import { GestoresService } from 'src/app/services/gestores.service';
import { LoginService } from 'src/app/services/login-participante.service';
import { MessageService } from 'primeng/api';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-cadastro-gestor',
  templateUrl: './cadastro-gestor.component.html',
  styleUrls: ['./cadastro-gestor.component.css']
})
export class CadastroGestorComponent implements OnInit {
  resposta: any;
  formGroup: FormGroup;
  gestor = new GestorDTO();
  token: string;
  senha: string;
  confirmacaoSenha:string;

  constructor(
    private spinner: NgxSpinnerService,
    protected gestores: GestoresService,
    protected messageService: MessageService,
    ) { }

  ngOnInit() {
    this.token = sessionStorage.getItem('token');

    this.formGroup = new FormGroup({
      nome: new FormControl(),
      cpf: new FormControl(),
      email: new FormControl(),
      senha: new FormControl(),
      confirmacaoSenha: new FormControl()
    })
  }
  salvarNovoGestor(){
    
  }

  public onSubmit(value){

    let email = this.formGroup.get('email').value
    let senha = this.formGroup.get('senha').value
    let confirmacaoSenha = this.formGroup.get('confirmacaoSenha').value
    let nome = this.formGroup.get('nome').value
    let cpf = this.formGroup.get('cpf').value
    let token = sessionStorage.getItem('token');
    
    if(senha == confirmacaoSenha){

      this.gestor.login = email
      this.gestor.senha = senha
      this.gestor.nome = nome
      this.gestor.cpf = cpf
      this.token = token
      

      this.gestores.salvarNovoGestor(this.token,this.gestor).then((data: GestorDTO) => {
        this.resposta = data;
        console.log("resposta",JSON.stringify(this.resposta))
        console.log("dados gestor",this.gestor)
        console.log("TOKEN",this.token)
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Atenção', detail: "O gestor foi cadastrado com sucesso!" });
        window.history.back();

      }, error => {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: error });
        console.log("error",error)
      });
    }else{
      alert("As senhas não conferem! Por favor, corrija.")
    }
  }
  public goBack(){
    //Impede o submit nessa função
    event.preventDefault();
    //============================

    window.history.back();
  }
}
